/* eslint-disable @typescript-eslint/no-empty-interface */
import { Injectable } from '@angular/core';
import { JSONRPCService } from '@s8l/client-tree-lib';
import { serviceURL } from './service';

export interface VstTrainer {
  uuid?: string;
  licences?: string[];
}

// ---

@Injectable({
  providedIn: 'root'
})
export class VstServerService extends JSONRPCService {
  public async list(): Promise<VstTrainer[]> {
    return this.message(serviceURL('VST_SERVER', '/admin/trainer'), 'list', {});
  }

  public async add(user: string, licence: string): Promise<VstTrainer[]> {
    return this.message(serviceURL('VST_SERVER', '/admin/trainer'), 'add', { user, licence });
  }

  public async remove(user: string, licence: string): Promise<VstTrainer[]> {
    return this.message(serviceURL('VST_SERVER', '/admin/trainer'), 'remove', { user, licence });
  }

  public async delete(user: string): Promise<VstTrainer[]> {
    return this.message(serviceURL('VST_SERVER', '/admin/trainer'), 'delete', { user });
  }
}
